import packageInfo from '../../package.json';

export const environment = {
  production: false,
  name: window["env"]["name"],
  cidade: window["env"]["cidade"],
  tempoRespostaHoras: window["env"]["tempoRespostaHoras"],
  lgBuscaPlaca: window["env"]["lgBuscaPlaca"],
  orgao: window["env"]["orgao"],
  logoSrc: window["env"]["logoSrc"],
  emblema: window["env"]["emblema"],
  protocol: window["env"]["protocol"],
  apiroot: window["env"]["apiroot"],
  host: window["env"]["host"],
  encryptType: window["env"]["encryptType"],
  saltMD5: window["env"]["saltMD5"],
  port: window["env"]["port"],
  context: window["env"]["context"],
  timeout: window["env"]["timeout"],
  maps: {
    lat: window["env"]["maps"]["latitude"],
    lng: window["env"]["maps"]["longitude"]
  },
  version: packageInfo.version
};
